<template>
  <div id="container">
    <user-image :img="imageUser"></user-image>
    <h2 class="animate__animated animate__fadeInDown">Transformadas 3D</h2>
    <menu-vertical
      class="menu"
      :explicacion="pathModulo.explicacion"
      :demostracion="pathModulo.demostracion"
      :actividad="pathModulo.actividad"
      :cuestionario="pathModulo.cuestionario"
    ></menu-vertical>
    <!-- <barra-herramientas /> -->
    <div>
      <h3 class="info1 animate__animated animate__fadeInRight">
        <span class="div" style="color: #00ff00; font-weight: bold">
          INSTRUCCIONES:
        </span>
        Para activar los controles y animaciones <br />
        <div class="div" style="color: #fff300; font-weight: bold">
          Tecla W para activar la translación
        </div>
        <div class="div" style="color: red; font-weight: bold">
          Tecla E para activar la rotación
        </div>
        <div class="div" style="color: #33bbff; font-weight: bold">
          Tecla R para activar la escala
        </div>
        <div class="div" style="font-weight: bold">
          Tecla Q para los controles de camara
        </div>
      </h3>
    </div>
    <div class="controles animate__animated animate__fadeInDown">
      Controles de camara:
      <span v-if="orbit !== null && orbit.enabled" style="color: #00ff00">
        ACTIVOS</span
      >
      <span v-else-if="orbit !== null && !orbit.enabled" style="color: red">
        INACTIVOS</span
      >
    </div>
    <!-- <router-link to="/actividad-sistema-de-coordenadas">Actividad</router-link> -->
    <div v-if="felicidades" class="felicidades">
      <img src="@/assets/img/icons3D/bombilla.png" alt="column" />
      <h2>¡FELICITACIONES!</h2>
      <p>
        Acabas de obtener otro logro, por finalizar la Demostacion de
        <b> Transformaciones 3D</b>.
      </p>
      <router-link class="botonLogro" to="/actividad-transformadas-3D"
        >Continuar</router-link
      >
    </div>
    <a v-if="continuar" @click="logro()">Continuar</a>
  </div>
</template>
<script>
import MenuVertical from "@/components/MenuVertical.vue";
import * as Three from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { TransformControls } from "three/examples/jsm/controls/TransformControls.js";
import { TWEEN } from "three/examples/jsm/libs/tween.module.min";
// import BarraHerramientas from "@/components/BarraHerramientas.vue";
import UserImage from "../../components/UserImage.vue";
export default {
  name: "DemostacionSistemaCoordenadas",
  components: {
    MenuVertical,
    UserImage,
  },
  data() {
    return {
      felicidades: false,
      continuar: false,
      cont: 1,
      animaciones: {
        position: false,
        scale: false,
        rotation: false,
      },
      siguiente: false,
      camera: null,
      scene: null,
      renderer: null,
      anim: null,
      raycaster: null,
      control: null,
      cube: null,
      orbit: null,
      decodeToken: null,
      imageUser:
        "https://cdn.pixabay.com/photo/2018/04/18/18/56/user-3331256__340.png",
      logros: [],
      pathModulo: {
        explicacion: "/transformadas-3d",
        demostracion: "/demostracion-transformadas-3d",
        actividad: "/actividad-transformadas-3d",
        cuestionario: "/cuestionario-transformadas-3d",
      },
    };
  },
  methods: {
    init: function () {
      let container = document.getElementById("container");
      this.camera = new Three.PerspectiveCamera(
        50,
        container.clientWidth / container.clientHeight,
        0.01,
        30000
      );
      this.camera.position.set(1000, 500, 1000);
      this.camera.lookAt(0, 200, 0);

      this.renderer = new Three.WebGLRenderer({ antialias: true });
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.setSize(window.innerWidth, window.innerHeight);
      container.appendChild(this.renderer.domElement);

      this.scene = new Three.Scene();
      this.scene.add(new Three.GridHelper(1000, 10, 0x888888, 0x444444));

      const light = new Three.AmbientLight(0xffffff, 2);
      light.position.set(1, 1, 1);
      this.scene.add(light);

      const geometry = new Three.BoxGeometry(200, 200, 200);
      const material = new Three.MeshLambertMaterial({ color: 0x33bbff });

      this.orbit = new OrbitControls(this.camera, this.renderer.domElement);
      this.orbit.update();
      this.orbit.enabled = true;
      // this.control.addEventListener("dragging-changed", function (event) {
      //   this.orbit.enabled = !event.value;
      // });
      this.cube = new Three.Mesh(geometry, material);
      this.scene.add(this.cube);

      this.control = new TransformControls(
        this.camera,
        this.renderer.domElement
      );
      this.control.addEventListener("change", () =>
        this.renderer.render(this.scene, this.camera)
      );

      this.control.attach(this.cube);
      this.scene.add(this.control);
      document.addEventListener("keydown", this.onDocumentKeyDown);
      document.addEventListener("keyup", this.onDocumentKeyUp);
    },
    onDocumentKeyDown(event) {
      switch (event.keyCode) {
        case 87: // W
          this.animarCubo("translate", true);
          this.control.setMode("translate");
          break;

        case 69: // E
          this.animarCubo("rotation", true);
          this.control.setMode("rotate");
          break;

        case 82: // R
          this.animarCubo("scale", true);
          this.control.setMode("scale");
          this.continuar = true;
          break;
        case 81: // Q
          this.orbit.enabled = !this.orbit.enabled;
          break;

        case 32: // Spacebar
          //this.control.enabled = !this.control.enabled;
          break;
      }
    },
    onDocumentKeyUp(event) {
      switch (event.keyCode) {
        case 16: // Shift
          this.control.setTranslationSnap(0, 0, 0);
          this.control.setRotationSnap(null);
          this.control.setScaleSnap(200);
          break;
      }
    },
    onWindowResize() {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();

      this.renderer.setSize(window.innerWidth, window.innerHeight);
    },
    animarCubo(value, enabled) {
      if (value == "translate" && enabled) {
        if (this.animaciones.position) {
          new TWEEN.Tween(this.cube.position)
            .to(
              {
                z: 200,
                y: 0,
                x: 0,
              },
              1000
            )
            .onComplete(() => {
              this.animaciones.position = false;
              this.animacionTerminada = true;
            })
            .start();
        } else {
          new TWEEN.Tween(this.cube.position)
            .to(
              {
                z: -200,
                y: 0,
                x: 0,
              },
              1000
            )
            .onComplete(() => {
              (this.animaciones.position = true),
                this.animarCubo("translate", true);
            })
            .start();
        }
      } else if (value == "scale" && enabled) {
        if (this.animaciones.scale) {
          new TWEEN.Tween(this.cube.scale)
            .to(
              {
                z: 1,
                y: 1,
                x: 1,
              },
              1000
            )
            .onComplete(() => {
              this.animaciones.scale = false;
              this.animacionTerminada = true;
            })
            .start();
        } else {
          new TWEEN.Tween(this.cube.scale)
            .to(
              {
                z: 3,
                y: 3,
                x: 3,
              },
              1000
            )
            .onComplete(() => {
              (this.animaciones.scale = true), this.animarCubo("scale", true);
            })
            .start();
        }
      } else if (value == "rotation" && enabled) {
        if (this.animaciones.rotation) {
          new TWEEN.Tween(this.cube.rotation)
            .to(
              {
                z: Math.PI / 2,
              },
              1000
            )
            .onComplete(() => {
              this.animaciones.rotation = false;
              this.animacionTerminada = true;
            })
            .start();
        } else {
          new TWEEN.Tween(this.cube.rotation)
            .to(
              {
                z: -Math.PI / 3,
              },
              1000
            )
            .onComplete(() => {
              (this.animaciones.rotation = true),
                this.animarCubo("rotation", true);
            })
            .start();
        }
      }
    },
    animate: function () {
      requestAnimationFrame(this.animate);
      TWEEN.update();
      this.renderer.render(this.scene, this.camera);
      window.addEventListener("resize", this.onWindowResize);
    },
    profile() {
      this.decodeToken = this.$getDataProfile(
        localStorage.getItem("token")
      ).uid;

      var axios = require("axios");

      var config = {
        method: "get",
        url: `https://restserver-cg.onrender.com/api/usuarios/${this.decodeToken}`,
        headers: {},
      };

      axios(config)
        .then((response) => {
          console.log(response.data);
          this.imageUser = response.data.img;
          this.logros = response.data.logros;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    logro() {
      this.felicidades = true;
      if (this.logros.indexOf("DemostracionTransformadas3d") != -1) {
        console.log("ya tiene este logro");
      } else {
        this.logros.push("DemostracionTransformadas3d");
        fetch(`https://restserver-cg.onrender.com/api/usuarios/${this.decodeToken}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: `{"logros":${JSON.stringify(this.logros)}}`,
        })
          .then((response) => {
            console.log(response);
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
  },
  mounted() {
    this.profile();
    this.init();
    this.animate();
  },
};
</script>
<style scoped>
#container {
  height: 100vh;
  width: 100vw;
  background: #fff;
}
.menu {
  position: absolute;
}
.info1 {
  display: block;
  position: absolute;
  background: #fff;
  width: 30%;
  right: 0;
  top: 5rem;
  padding: 1rem;
  border-end-start-radius: 5px;
  border-start-start-radius: 5px;
  text-align: initial;
}
.controles {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  padding: 1rem;
  border-end-start-radius: 5px;
  border-start-start-radius: 5px;
  text-align: initial;
  font-size: 1rem;
  color: white;
  font-weight: bold;
}
a {
  font-size: 1.2rem;
  width: var(--espacio);
  padding: 0.8rem 1rem;
  border-radius: 6px;
  font-family: "Exo 2", sans-serif;
  background: #ffc300;
  font-weight: bold;
  cursor: pointer;
  position: absolute;
  /* right: calc(40%-var(--espacio)); */
  right: 2rem;
  top: 30rem;
  padding: 1rem;
}
h2 {
  position: absolute;
  margin-top: 1rem;
  margin: auto;
  right: 0;
  left: 0;
  width: fit-content;
  font-size: 1.5rem;
  color: white;
  font-weight: bold;
  font-family: "Exo 2", sans-serif;
}
.felicidades {
  position: absolute;
  background: white;
  border-radius: 10px;
  width: 40%;
  height: fit-content;
  /* height: 50%; */
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  font-family: "Exo 2", sans-serif !important;
  color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.felicidades h2 {
  position: relative;
  font-weight: bold;
  font-size: 2rem;
  margin-bottom: 1rem;
  padding: 0.5rem;
  font-family: "Exo 2", sans-serif !important;
  color: black;
}
.felicidades p {
  color: black;
  /* font-weight: bold; */
  font-family: "Exo 2", sans-serif !important;
  font-size: 1rem;
  margin-bottom: 1rem;
  padding: 0 1.5rem;
}
.felicidades img {
  margin: 1rem;
  width: 35%;
}
.botonLogro {
  position: initial;
  z-index: 10;
  font-size: 1.2rem;
  width: var(--espacio);
  padding: 0.8rem 1rem;
  border-radius: 6px;
  font-family: "Exo 2", sans-serif;
  background: #ffc300;
  font-weight: bold;
  cursor: pointer;
  padding: 1rem;
  margin: 1rem;
}
</style>
